import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translate } from "./translations";

const LanguageContext = createContext({ lang: "it", setLang: () => {}, t: (k) => k });

const STORAGE_KEY = "velora-lang";

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "it";
        return localStorage.getItem(STORAGE_KEY) || "it";
    });

    useEffect(() => {
        if (typeof document !== "undefined") document.documentElement.lang = lang;
    }, [lang]);

    const setLang = useCallback((l) => {
        setLangState(l);
        try { localStorage.setItem(STORAGE_KEY, l); } catch (e) {}
    }, []);

    const t = useCallback((key) => translate(lang, key), [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLang() {
    return useContext(LanguageContext);
}

// Convenience component for HTML-safe translated strings
export function T({ k, as: As = "span", ...props }) {
    const { t } = useLang();
    return <As dangerouslySetInnerHTML={{ __html: t(k) }} {...props} />;
}
